import React from 'react';

const STATUS_LABELS = {
  initiated: { label: 'Iniciada', className: 'badge-info' },
  processing: { label: 'Processando', className: 'badge-warning' },
  done: { label: 'Concluída', className: 'badge-success' },
  error: { label: 'Erro', className: 'badge-danger' },
  canceled: { label: 'Cancelada', className: 'badge-secondary' },
};

/**
 * Tabela de histórico de importações.
 *
 * @param {Array}    reports       - Lista de relatórios
 * @param {Function} getTypeLabel  - Converte value → label
 */
const ImportHistory = ({ reports, getTypeLabel }) => {
  if (!reports || reports.length === 0) return null;

  const getStatusBadge = (status) => {
    const info = STATUS_LABELS[status] || { label: status, className: 'badge-secondary' };
    return <span className={`badge ${info.className}`}>{info.label}</span>;
  };

  return (
    <div className="card card-outline card-secondary">
      <div className="card-header">
        <h3 className="card-title">
          <i className="fa-solid fa-clock-rotate-left mr-1"></i>
          Últimas Importações
        </h3>
      </div>
      <div className="card-body p-0">
        <table className="table table-striped table-sm mb-0">
          <thead>
            <tr>
              <th>Data</th>
              <th>Tipos</th>
              <th>Status</th>
              <th>Tempo Total</th>
              <th>Mensagem</th>
            </tr>
          </thead>
          <tbody>
            {reports.map((report, idx) => {
              const types = report.types
                ? (Array.isArray(report.types)
                    ? report.types
                    : JSON.parse(report.types)
                  )
                    .map(getTypeLabel)
                    .join(', ')
                : '—';

              return (
                <tr key={report.import_id || idx}>
                  <td>{report.import_created}</td>
                  <td>{types}</td>
                  <td>{getStatusBadge(report.import_status)}</td>
                  <td>{report.total_time || '—'}</td>
                  <td>
                    <small>{report.message || '—'}</small>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ImportHistory;
